import React, { useState } from "react";
import SummariseBtn from "../../../../assets/images/common/SummariseBtn.svg";
import { getAccessToken } from "../../../../helpers/api_helper";
import Loader from "../../../../common/components/Loader";
import EventSource from "eventsource";
import { getStorageXSiteId } from "../../../../common/utils/common"

const Summarise = ({ playerOid, setAINote }) => {
  const APP_URL = process.env.REACT_APP_API_URL;
  const [isLoading, setIsLoading] = useState(false);
  const xSiteId = getStorageXSiteId();

  const onClickSummarise = async () => {
    setIsLoading(true);

    const output = document.getElementById('summariseOutput');
    output.textContent = 'Generating...';

    const token = getAccessToken();
    const baseUrl = `${APP_URL}/api/ai/player/${playerOid}/summarize`;
    const urlWithToken = `${baseUrl}?token=Bearer ${token}`;

    try {
      const eventSource = new EventSource(urlWithToken, {
        headers: {
          'x-site-id': xSiteId,
        },
      });
      let firstResponse = true;

      eventSource.onmessage = function (event) {
        if (firstResponse) {
          output.textContent = '';
          firstResponse = false;
        }
        const data = event.data;
        output.textContent += data + '';
      };

      eventSource.onerror = function (event) {
        if (event.data) {
          output.textContent = `\n\n${event.data}`;
        }
        eventSource.close();
        setIsLoading(false);
        setAINote(output.textContent);
      };
    } catch (error) {
      console.log('Error fetching summary:', error);
      output.textContent = 'Error generating summary';
      setIsLoading(false);
    }
  };

  return (
    isLoading ? (<Loader />) : (
      <div className='d-flex justify-content-center'>
        <button onClick={onClickSummarise} className='summariseBtn' disabled={isLoading}>
          <img src={SummariseBtn} alt="Summarise" />
        </button>
      </div>
    )
  );
};

export default Summarise;
